import type { Maybe } from '@amazon/vinyl-util'
import type { DownloadError } from '@/downloads/downloadDmls'

/**
 * The message for a downloaded track that can't play until the customer acts: its license ran out
 * (the app has been offline too long; going online fixes it) or the plan no longer covers it.
 * Null for any other failure. Read by shape: the playback binding must not load the download code.
 */
export function downloadPlaybackFailureKey(
    cause: unknown
): 'dmusic_download_expired' | 'dmusic_download_not_on_plan' | null {
    const error = cause as Maybe<Partial<Pick<DownloadError, 'name' | 'failure'>>>
    if (error?.name !== 'DownloadError') return null
    if (error.failure === 'expired') return 'dmusic_download_expired'
    if (error.failure === 'notEligible') return 'dmusic_download_not_on_plan'
    return null
}
